import i18n from 'i18n'
import { intlLocale } from 'i18n/config'
import { translateCountryCode } from 'ui-seeker/utils'
import { formatWithFlag } from 'app/utils'

// Defaults are resolved at CALL time (each column build), so i18n.language is already set.
export const sampleFilter = (text, filterType='textField') => ({
    filterType: filterType,
    customFilterListOptions: { render: v => `${text}: ${v}` },
})

export const sampleDropdownFilter = (text, emptyText=i18n.t('common:filters.any')) => ({
    customFilterListOptions: { render: v => `${text}: ${v ? v : emptyText}` },
    filterOptions: {
        renderValue: v => v ? v : emptyText
    },
})

export const sampleBooleanFilter = (text, {trueText=i18n.t('common:actions.yes'), falseText=i18n.t('common:actions.no')}={}) => ({
    filterType: 'checkbox',
    customFilterListOptions: { render: v => `${text}: ${v ? trueText : falseText}` },
    filterOptions: {
        renderValue: v => v ? trueText : falseText
    },
})

export const countryDropdownFilter = (text='country', emptyText=i18n.t('common:filters.any')) => ({
    customFilterListOptions: { render: v => `${text}: ${v ? translateCountryCode(v, intlLocale(i18n.language)) : emptyText}` },
    filterOptions: {
        renderValue: v => v ? formatWithFlag(v, {countryName: true}) : emptyText
    },
})